// console-spa entry — Task 16.1
//
// 简易 hash 路由 + React 18 入口。MVP 不引入 TanStack Router / Redux，
// 只用 React useState + 自定义 useHashRoute 让 4 个页面切换：
//   #/login   登录
//   #/sites   Site 列表 / 创建 / 编辑 / 重置 secret
//   #/dashboard 仪表盘（AE SQL 通过率 / 拒绝率 / challenge 占比）
//   #/logs    调用日志查询
//
// API 客户端 (lib/api.ts) 自动注入 X-Captcha-Bearer header；登录态由
// localStorage 持久化（Task 4.3 console 端 JWT 已在 Wave 3 完成）。

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const rootEl = document.getElementById('root');
if (rootEl !== null) {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
